import * as actionTypes from "constants/actionTypes";
import { selectAccountFeature } from "reducers/account/features";
import {
  SALESFORCE_INTEGRATION,
  HUBSPOT_TWO_WAY_INTEGRATION,
  ZENDESK_SELL_INTEGRATION,
  ZENDESK_SUPPORT_INTEGRATION
} from "constants/features";

const initialState = {
  synced: false,
  integrationTypes: {}
};

export default function integrationTypes(state = initialState, action) {
  switch (action.type) {
    case actionTypes.REPLACE_INTEGRATION_TYPES:
      return {
        synced: true,
        integrationTypes: action.payload
      };
    default:
      return state;
  }
}

export const selectAvailableIntegrationTypes = state => {
  const allIntegrations = Object.values(
    state.integrationTypes.integrationTypes
  );

  return allIntegrations.filter(integration => {
    const integrationToFeatureFlag = {
      salesforce: SALESFORCE_INTEGRATION,
      "hubspot-two-way-integration": HUBSPOT_TWO_WAY_INTEGRATION,
      "zendesk-sell-two-way-integration": ZENDESK_SELL_INTEGRATION,
      "zendesk-support-two-way-integration": ZENDESK_SUPPORT_INTEGRATION
    };

    if (integration.featureFlagged) {
      return (
        integration.featureFlagged &&
        selectAccountFeature(state, integrationToFeatureFlag[integration.id])
      );
    }

    return integration;
  });
};
export const selectIntegrationTypes = state =>
  state.integrationTypes.integrationTypes;
export const selectAreIntegrationTypesSynced = state =>
  state.integrationTypes.synced;
